import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Layout from './components/layout/Layout';
import './index.css';

const HomePage = React.lazy(() => import('./pages/HomePage'));
const AboutPage = React.lazy(() => import('./pages/AboutPage'));
const ServicesPage = React.lazy(() => import('./pages/ServicesPage'));
const ContactPage = React.lazy(() => import('./pages/ContactPage'));
const TeamPage = React.lazy(() => import('./pages/TeamPage'));
const ReferralPage = React.lazy(() => import('./pages/ReferralPage'));

// Scroll to top on route change
function ScrollToTop() {
	const { pathname } = useLocation();
	React.useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);
	return null;
}

// Track Meta Pixel PageView on route changes (SPA)
function MetaPixelRouteTracker() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fbqGlobal: any = (window as unknown as { fbq?: unknown }).fbq;
    if (typeof fbqGlobal === 'function') {
      try {
        fbqGlobal('track', 'PageView');
      } catch {
        // no-op
      }
    }
  }, [pathname]);
  return null;
}

function App() {
	return (
		<Router>
			<ScrollToTop />
			<MetaPixelRouteTracker />
			<Layout>
				<React.Suspense fallback={<div />}> 
					<Routes>
						<Route path="/" element={<HomePage />} />
						<Route path="/about" element={<AboutPage />} />
						<Route path="/services" element={<ServicesPage />} />
						<Route path="/team" element={<TeamPage />} />
						<Route path="/referrals" element={<ReferralPage />} />
						<Route path="/contact" element={<ContactPage />} />
					</Routes>
				</React.Suspense>
			</Layout>
		</Router>
	);
}

export default App;
